import TransfersVehicleType
    from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersVehicle.type";
import VehicleSnippet from "./VehicleSnippet";
import Translation from "@/features/translation/components/Translation";
import { TransfersDataType } from "@/pages/searchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import useCompanyStyle from "@Hooks/selector/useCompanyStyle";

interface VehicleSnippetsProps {
    vehicles: TransfersVehicleType[],
    additionalClassName?: string,
}

function VehicleSnippets({vehicles, additionalClassName = ""}: VehicleSnippetsProps) {

    const {id: storeId} = useCompanyStyle();

    // Don't show VehicleSnippets for specific store IDs
    if (["1001", "1003", "1004"].includes(storeId?.toString())) {
        return null;
    }

    return (
        <div className="gb--vehicle-wrapper">
            <h3>
                <Translation translationKey="transfers_banner.header" />
            </h3>
            <Translation translationKey="transfers_banner.text" />
            <div className={`gb--cards ${additionalClassName}`}>
                {vehicles.map((vehicleData) => (
                    <VehicleSnippet
                        vehicleData={vehicleData}
                        key={vehicleData.vehicleGroupName}
                    />
                ))}
            </div>
        </div>
    )
}

export default VehicleSnippets